import JobContainer from './JobsContainer';

export default JobContainer;